// removed by extract-text-webpack-plugin
module.exports = {"Container":"Vaccination__Container__2z--W","BtnAddDiv":"Vaccination__BtnAddDiv__1gj9r"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Vaccination/Vaccination.css
// module id = 127
// module chunks = 0